import React, { useState, useEffect, useRef, useContext } from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { connect } from 'react-redux';
import {
  Drawer,
  TextInputWithLabel,
  Checkbox,
  PopupMenu,
  Loader,
  Button,
  DatePicker
} from 'quantux-ui';
import {
  deletePatientFromNewCaseSchedule,
  deletePatientFromCaseSchedule
} from '../../actions';
import PatientInfo from '../patient-dashboard/patient-info';
import AddPatientToSchedule from './add-patient-to-schedule';
import {
  BASE_URL,
  debugLogToConsole,
  padZero,
  parseDateFromIsoString,
  CASE_SCHEDULE_OP_MODE
} from '../../utils';
import { blue, gray, salmon } from '../../theme';

const TODAY = new Date();

const idIcon = (
  <svg
    width="20"
    height="15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.406 0h17.188C19.37 0 20 .629 20 1.406v12.188C20 14.37 19.371 15 18.594 15H1.406A1.405 1.405 0 0 1 0 13.594V1.406C0 .63.629 0 1.406 0ZM8.75 11.094c0 .777-.629 1.406-1.406 1.406H3.906A1.405 1.405 0 0 1 2.5 11.094V9.375c0-1.078.545-2.027 1.375-2.59a2.5 2.5 0 1 1 3.5 0 3.122 3.122 0 0 1 1.375 2.59v1.719ZM6.719 5a1.094 1.094 0 1 0-2.19.001A1.094 1.094 0 0 0 6.72 5ZM3.906 9.473c0-.006 0-.012.002-.02-.002-.025-.002-.053-.002-.078a1.719 1.719 0 0 1 3.438 0c0 .027 0 .053-.002.078.002.006.002.012.002.02v1.523a.097.097 0 0 1-.098.098H4.004a.097.097 0 0 1-.098-.098V9.473Zm14.688 4.12H1.406V1.407h17.188v12.188Zm-3.047-5.39h-4.844a.703.703 0 1 1 0-1.406h4.844a.703.703 0 1 1 0 1.406Zm-4.844 3.203h3.594a.703.703 0 1 0 0-1.406h-3.594a.703.703 0 1 0 0 1.406ZM16.797 5h-6.094a.703.703 0 1 1 0-1.406h6.094a.703.703 0 1 1 0 1.406Z"
      fill="#9CF"
    />
  </svg>
);

const PatientTab = (props) => {
  const [showEditPatientDrawer, setShowEditPatientDrawer] = useState(false);
  const [patientFirstName, setPatientFirstName] = useState('');
  const [patientMiddleName, setPatientMiddleName] = useState('');
  const [patientLastName, setPatientLastName] = useState('');
  const [patientSSN1, setPatientSSN1] = useState('');
  const [patientSSN2, setPatientSSN2] = useState('');
  const [patientSSN3, setPatientSSN3] = useState('');
  const [isPatientDobPristine, setIsPatientDobPristine] = useState(true);
  const [showPatientDobAlert, setShowPatientDobAlert] = useState(true);
  const [patientDobMonth, setPatientDobMonth] = useState(TODAY.getMonth());
  const [patientDobDate, setPatientDobDate] = useState(TODAY.getDate());
  const [patientDobYear, setPatientDobYear] = useState(TODAY.getFullYear());
  const [patientDisplayName, setPatientDisplayName] = useState('');
  const [isPatientDisplayNamePristine, setIsPatientDisplayNamePristine] = useState(true);
  const [isPatientDisplayNameValid, setIsPatientDisplayNameValid] = useState(true);
  const [patientUserName, setPatientUserName] = useState('');
  const [isPatientUserNamePristine, setIsPatientUserNamePristine] = useState(true);
  const [isPatientUserNameDuplicate, setIsPatientUserNameDuplicate] = useState(false);
  const [isPatientUserNameValid, setIsPatientUserNameValid] = useState(true);
  // Home Address
  const [patientHomeStreetAddress, setPatientHomeStreetAddress] = useState('');
  const [patientHomeSuite, setPatientHomeSuite] = useState('');
  const [patientHomeCity, setPatientHomeCity] = useState('');
  const [patientHomeState, setPatientHomeState] = useState('');
  const [patientHomeZip, setPatientHomeZip] = useState('');
  // Mailing Address
  const [isPatientMailingAddressSameAsHomeAddress, setIsPatientMailingAddressSameAsHomeAddress] = useState(false);
  const [patientMailingStreetAddress, setPatientMailingStreetAddress] = useState('');
  const [patientMailingSuite, setPatientMailingSuite] = useState('');
  const [patientMailingCity, setPatientMailingCity] = useState('');
  const [patientMailingState, setPatientMailingState] = useState('');
  const [patientMailingZip, setPatientMailingZip] = useState('');
  // Mobile, Phone and Email
  const [patientMobile, setPatientMobile] = useState('');
  const [patientContactType, setPatientContactType] = useState('mobile');
  const [patientEmail, setPatientEmail] = useState('');
  const [canUpdatePatient, setCanUpdatePatient] = useState(true);

  const [isContactMenuOpen, setIsContactMenuOpen] = useState(false);
  const [showFrontCropperDrawer, toggleFrontCropperDrawer] = useState(false);
  const [patientFrontIdImageUrl, setPatientFrontIdImageUrl] = useState('https://quantumtrader.s3.amazonaws.com/default_insurance.jpg');
  const [showFrontCropper, setShowFrontCropper] = useState(false);
  const [isFrontUploading, setIsFrontUploading] = useState(false);
  const [showFrontIdLoader, setShowFrontIdLoader] = useState(false);

  const [showBackCropperDrawer, toggleBackCropperDrawer] = useState(false);
  const [patientBackIdImageUrl, setPatientBackIdImageUrl] = useState('https://quantumtrader.s3.amazonaws.com/default_insurance.jpg');
  const [showBackCropper, setShowBackCropper] = useState(false);
  const [isBackUploading, setIsBackUploading] = useState(false);
  const [showBackIdLoader, setShowBackIdLoader] = useState(false);

  const [showPatientAvatarCropperDrawer, setShowPatientAvatarCropperDrawer] = useState(false);
  const [patientAvatarImageUrl, setPatientAvatarImageUrl] = useState('https://quantumtrader.s3.amazonaws.com/default-user-avatar.svg');
  const [showPatientAvatarCropper, setShowPatientAvatarCropper] = useState(false);
  const [isPatientAvatarUploading, setIsPatientAvatarUploading] = useState(false);

  // ___ PROPS ________________________________________________________________
  let patientData = {};
  if (props.opMode === CASE_SCHEDULE_OP_MODE.newSchedule) {
    patientData = props.newCaseSchedulePatient;
  } else if (props.opMode === CASE_SCHEDULE_OP_MODE.updatedSchedule) {
    patientData = props.activeCaseSchedulePatientData;
  } else if (props.opMode === CASE_SCHEDULE_OP_MODE.caseBlockNewCase) {
    const { patientId } = props.caseBlockActiveCaseSchedule;
    if (patientId) {
      patientData = props.caseBlockPatients[patientId];
    }
  }

  if (props.isEditingCaseBlock) {
    const { patientId } = props.caseBlockActiveCaseSchedule;
    if (patientId) {
      patientData = props.caseBlockPatients[patientId];
    }
  }

  // ___ REFS _________________________________________________________________
  const contactRef = useRef();
  const drawerAvatarRef = useRef();
  const frontCardRef = useRef();
  const backCardRef = useRef();

  // ___ EFFECTS ______________________________________________________________

  // Patient username unique effect
  useEffect(() => {
    if (patientUserName === patientData.userName) {
      setIsPatientUserNameDuplicate(false);
    } else if (patientUserName.length >= 2 && patientUserName.length <= 20 && patientUserName.indexOf(' ') < 0) {
      const url = new URL(`${BASE_URL}/patients/checkDuplicateUserName`);
      const params = { userName: patientUserName };
      url.search = new URLSearchParams(params).toString();

      fetch(url)
        .then(response => response.text())
        .then(result => {
          const reqData = JSON.parse(result);
          debugLogToConsole(reqData);
          if (reqData.success) {
            setIsPatientUserNameDuplicate(reqData.isDuplicate);
          } else {
            setIsPatientUserNameDuplicate(true);
          }
        })
        .catch(error => console.log('error', error));
    }
  }, [patientUserName]);

  // Patient mailing address same as home address
  useEffect(() => {
    if (isPatientMailingAddressSameAsHomeAddress) {
      setPatientMailingStreetAddress('');
      setPatientMailingSuite('');
      setPatientMailingCity('');
      setPatientMailingState('');
      setPatientMailingZip('');
    }
  }, [isPatientMailingAddressSameAsHomeAddress]);

  // Edit Patient Drawer Accept button disable flag
  useEffect(() => {
    setCanUpdatePatient(
      isPatientUserNameValid &&
      !isPatientUserNameDuplicate &&
      isPatientDisplayNameValid &&
      patientLastName.length >= 2
    );
  }, [
    isPatientUserNameValid,
    isPatientUserNameDuplicate,
    patientLastName,
    isPatientDisplayNameValid
  ]);

  // ___ EVENT HANDLERS _______________________________________________________

  const handleOnDeletePatient = (patientId) => {
    props.onDeletePatient(patientId, props.isDashboard);
  };

  const handleOnEditPatient = () => {
    const {
      avatar = 'https://quantumtrader.s3.amazonaws.com/default-user-avatar.svg',
      userName,
      displayName,
      firstName,
      middleName,
      lastName,
      dob,
      ssn1,
      ssn2,
      ssn3,
      homeAddress = {},
      mailingAddress = {},
      mailingAddressSameAsHomeAddress,
      email,
      contactType,
      mobile,
      patientIdFrontScan: idFront = 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg',
      patientIdFrontScan: idBack = 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg'
    } = patientData;

    setPatientFirstName(firstName);
    setPatientMiddleName(middleName);
    setPatientLastName(lastName);
    setPatientUserName(userName);
    setPatientDisplayName(displayName);
    setPatientSSN1(ssn1);
    setPatientSSN2(ssn2);
    setPatientSSN3(ssn3);
    setPatientAvatarImageUrl(avatar);
    setPatientEmail(email);
    setPatientMobile(mobile);
    setPatientContactType(contactType);
    setIsPatientMailingAddressSameAsHomeAddress(mailingAddressSameAsHomeAddress);
    setPatientFrontIdImageUrl(idFront);
    setPatientBackIdImageUrl(idBack);
    // Patient DOB
    const { year, month, date } = parseDateFromIsoString(dob);
    setPatientDobYear(year);
    setPatientDobMonth(month);
    setPatientDobDate(date);
    setIsPatientDobPristine(false);
    setShowPatientDobAlert(false);
    // Patient Home & Mailing Address
    const {
      streetAddress1: hStreetAddress = '',
      suite: hSuite = '',
      city: hCity = '',
      zip: hZip = '',
      state: hState = ''
    } = homeAddress;

    setPatientHomeStreetAddress(hStreetAddress);
    setPatientHomeSuite(hSuite);
    setPatientHomeCity(hCity);
    setPatientHomeState(hState);
    setPatientHomeZip(hZip);

    if (mailingAddressSameAsHomeAddress) {
      setPatientMailingStreetAddress(hStreetAddress);
      setPatientMailingSuite(hSuite);
      setPatientMailingCity(hCity);
      setPatientMailingState(hState);
      setPatientMailingZip(hZip);
    } else {
      const {
        streetAddress1: mStreetAddress = '',
        suite: mSuite = '',
        city: mCity = '',
        zip: mZip = '',
        state: mState = ''
      } = mailingAddress;

      setPatientMailingStreetAddress(mStreetAddress);
      setPatientMailingSuite(mSuite);
      setPatientMailingCity(mCity);
      setPatientMailingState(mState);
      setPatientMailingZip(mZip);
    }

    setShowEditPatientDrawer(true);
  };

  const handleOnEditPatientFirstName = (e) => {
    const { value } = e.target;
    setPatientFirstName(value);
  };

  const handleOnEditPatientMiddleName = (e) => {
    const { value } = e.target;
    setPatientMiddleName(value);
  };

  const handleOnEditPatientLastName = (e) => {
    const { value } = e.target;
    setPatientLastName(value);
  };

  const handleOnEditPatientSSN1 = (e) => {
    const { value } = e.target;
    const val = parseInt(value) + '';
    if (!isNaN(val)) {
      if (val.length > 3) {
        setPatientSSN1(val.substring(0, 3));
      } else {
        setPatientSSN1(val);
      }
    } else {
      setPatientSSN1('');
    }
  };

  const handleOnEditPatientSSN2 = (e) => {
    const { value } = e.target;
    const val = parseInt(value) + '';
    if (!isNaN(val)) {
      if (val.length > 2) {
        setPatientSSN2(val.substring(0, 2));
      } else {
        setPatientSSN2(val);
      }
    } else {
      setPatientSSN2('');
    }
  };

  const handleOnEditPatientSSN3 = (e) => {
    const { value } = e.target;
    const val = parseInt(value) + '';
    if (!isNaN(val)) {
      if (val.length > 4) {
        setPatientSSN3(val.substring(0, 4));
      } else {
        setPatientSSN3(val);
      }
    } else {
      setPatientSSN3('');
    }
  };

  const handleOnEditPatientDisplayName = (e) => {
    const { value } = e.target;
    setPatientDisplayName(value);
    setIsPatientDisplayNamePristine(false);
    setIsPatientDisplayNameValid(value.length >= 2 && value.length <= 40);
  };

  const handleOnEditPatientUserName = (e) => {
    const { value } = e.target;
    setPatientUserName(value);
    setIsPatientUserNamePristine(false);
    setIsPatientUserNameValid(value.length >= 2 && value.length <= 20 && value.indexOf(' ') < 0);
  };

  const handleOnEditPatientHomeStreetAddress = (e) => {
    const { value } = e.target;
    setPatientHomeStreetAddress(value);
  };

  const handleOnEditPatientHomeSuite = (e) => {
    const { value } = e.target;
    setPatientHomeSuite(value);
  };

  const handleOnEditPatientHomeCity = (e) => {
    const { value } = e.target;
    setPatientHomeCity(value);
  };

  const handleOnEditPatientHomeState = (e) => {
    const { value } = e.target;
    setPatientHomeState(value);
  };

  const handleOnEditPatientHomeZip = (e) => {
    const { value } = e.target;
    setPatientHomeZip(value);
  };

  const handleOnEditPatientMailingStreetAddress = (e) => {
    const { value } = e.target;
    setPatientMailingStreetAddress(value);
  };

  const handleOnEditPatientMailingSuite = (e) => {
    const { value } = e.target;
    setPatientMailingSuite(value);
  };

  const handleOnEditPatientMailingCity = (e) => {
    const { value } = e.target;
    setPatientMailingCity(value);
  };

  const handleOnEditPatientMailingState = (e) => {
    const { value } = e.target;
    setPatientMailingState(value);
  };

  const handleOnEditPatientMailingZip = (e) => {
    const { value } = e.target;
    setPatientMailingZip(value);
  };

  const handleOnEditPatientMobile = (e) => {
    const { value } = e.target;
    setPatientMobile(value);
  };

  const handleOnEditPatientEmail = (e) => {
    const { value } = e.target;
    setPatientEmail(value);
  };

  const handleOnChangePatientContactType = (val) => {
    setPatientContactType(val);
  };

  const handleOnClickSavePatientProfile = () => {
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('patientId', patientData._id);
    formData.append('firstName', patientFirstName);
    formData.append('middleName', patientMiddleName);
    formData.append('lastName', patientLastName);
    //
    formData.append('ssn1', patientSSN1);
    formData.append('ssn2', patientSSN2);
    formData.append('ssn3', patientSSN3);
    formData.append('dob', `${patientDobYear}-${padZero(patientDobMonth + 1)}-${padZero(patientDobDate)}` + 'T00:00:00.000Z');
    //
    formData.append('displayName', patientDisplayName);
    formData.append('userName', patientUserName);
    //
    formData.append('homeStreetAddress', patientHomeStreetAddress);
    formData.append('homeSuite', patientHomeSuite);
    formData.append('homeCity', patientHomeCity);
    formData.append('homeState', patientHomeState);
    formData.append('homeZip', patientHomeZip);
    //
    formData.append('mailingAddressSameAsHomeAddress', isPatientMailingAddressSameAsHomeAddress);
    if (!isPatientMailingAddressSameAsHomeAddress) {
      formData.append('mailingStreetAddress', patientMailingStreetAddress);
      formData.append('mailingSuite', patientMailingSuite);
      formData.append('mailingCity', patientMailingCity);
      formData.append('mailingState', patientMailingState);
      formData.append('mailingZip', patientMailingZip);
    }
    //
    formData.append('mobile', patientMobile);
    formData.append('contactType', patientContactType);
    // formData.append('phone', patientPhone);
    formData.append('email', patientEmail);

    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };

    fetch(`${BASE_URL}/patients/updatePatientProfile`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        console.log(res);
        if (res.success) {
          setShowEditPatientDrawer(false);
          props.onReloadPatientData();
        }
      })
      .catch(error => console.log('error', error));
  };

  // ___ STYLES _______________________________________________________________
  const styles = StyleSheet.create({
    sideDrawerContainer: {
      background: '#002448',
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    sideDrawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    sideDrawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    sideDrawerBanner: {
      position: 'relative',
      padding: '8px',
      flexShrink: '0'
    },
    sideDrawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    sideDrawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    sideDrawerContentArea: {
      overflowY: 'auto',
      overflowX: 'hidden',
      color: gray[300],
      flexGrow: '1'
      // padding: '8px'
    },
    sideDrawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    sideDrawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    sideDrawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    sideDrawerUserCardText: {
      fontSize: '12px'
    },
    sideDrawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: '#002448',
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      flexShrink: '0',
      paddingRight: '8px',
      position: 'absolute',
      bottom: '0'
    },
    sideDrawerLinkStyles: {
      color: gray[300],
      ':visited': {
        color: gray[300]
      }
    },
    sideDrawerSelectedLink: {
      color: blue[500]
    },
    errMsg: {
      color: '#FF6060',
      fontSize: '12px'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '4px',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    popupMenuContainer: {
      width: '110px',
      background: blue[900],
      paddingBottom: '1px',
      borderRadius: '5px',
      overflowY: 'auto',
      maxHeight: '200px'
    },
    popupMenuItemSmall: {
      height: '25px',
      display: 'flex',
      fontSize: '14px',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0',
      paddingLeft: '8px',
      ':not(.selected):hover': {
        backgroundColor: '#0066CC',
        color: 'white'
      }
    },
    selectedPopupMenuItemSmall: {
      backgroundColor: '#0066CC',
      color: 'white'
    }
  });

  return (
    <>
      {/* Edit Patient Profile */}
      {showEditPatientDrawer &&
        <Drawer
          placement="right"
          visible={showEditPatientDrawer}
          toggleDrawer={() => setShowEditPatientDrawer(false)}
          zIndex="2600"
          width={window.innerWidth <= 700 ? window.innerWidth : 375}
        >
          {/* Drawer Container */}
          <div className={`p-2 ${css(styles.sideDrawerContainer)}`}>
            {/* Header */}
            <div className={css(styles.sideDrawerHeader)}>
              <div className='fx fx__hv-center'>
                <i className='mr-2 fa fa-lg fa-user' />
                <div>Edit Patient Profile</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.sideDrawerHeaderCloseIcon)}`}
                onClick={() => setShowEditPatientDrawer(false)}
              />
            </div>
            {/* Content */}
            <div className={css(styles.sideDrawerContentArea)}>
              {/* Patient First, Middle and Last Name */}
              <div className='fx'>
                {/* Patient First Name */}
                <div>
                  <TextInputWithLabel
                    value={patientFirstName}
                    titleText="First Name"
                    titleFontSize={12}
                    isCompactLayout={true}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={115}
                    onChange={handleOnEditPatientFirstName}
                  />
                </div>
                {/* Patient Middle Name */}
                <div className='ml-2'>
                  <TextInputWithLabel
                    value={patientMiddleName}
                    titleText="Middle Name"
                    titleFontSize={12}
                    isCompactLayout={true}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={113}
                    onChange={handleOnEditPatientMiddleName}
                  />
                </div>
                {/* Patient Last Name */}
                <div className='ml-2'>
                  <TextInputWithLabel
                    value={patientLastName}
                    titleText="Last Name"
                    titleFontSize={12}
                    isCompactLayout={true}
                    titleColor={gray[200]}
                    textColor="white"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={114}
                    onChange={handleOnEditPatientLastName}
                  />
                </div>
              </div>
              {/* Patient SSN and DOB */}
              <div className='fx'>
                {/* SSN & DOB */}
                <div className='mt-4'>
                  <div className={css(styles.sectionHeading)}>SS#</div>
                  <div
                    className='fx'
                    style={{
                      alignItems: 'flex-end',
                      marginTop: '-10px'
                    }}
                  >
                    <div className='fx'>
                      <TextInputWithLabel
                        value={patientSSN1}
                        titleText=''
                        placeholder='???'
                        titleFontSize={12}
                        fontSize={12}
                        isCompactLayout={false}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={26}
                        onChange={handleOnEditPatientSSN1}
                      />
                      <div className={css(styles.ssnSeparator)}>-</div>
                      <TextInputWithLabel
                        value={patientSSN2}
                        titleText=''
                        placeholder='??'
                        titleFontSize={12}
                        fontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={26}
                        onChange={handleOnEditPatientSSN2}
                      />
                      <div className={css(styles.ssnSeparator)}>-</div>
                      <TextInputWithLabel
                        value={patientSSN3}
                        titleText=''
                        placeholder='????'
                        titleFontSize={12}
                        fontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={35}
                        onChange={handleOnEditPatientSSN3}
                      />
                    </div>
                    {/* DOB */}
                    <div className='fx' style={{ marginLeft: '40px' }}>
                      <i className='mr-2 fa fa-calendar' style={{ marginTop: '2px' }} />
                      <div className={`pr-2 ${css(styles.sectionHeading)}`}>
                        Date of Birth
                      </div>
                      <DatePicker
                        left={0}
                        right={-10}
                        date={patientDobDate}
                        month={patientDobMonth}
                        year={patientDobYear}
                        isPrisitine={isPatientDobPristine}
                        color={showPatientDobAlert ? salmon[500] : blue[400]}
                        noUnderline
                        onChangeDate={(year, month, date) => {
                          setShowPatientDobAlert(false);
                          setPatientDobDate(date);
                          setPatientDobMonth(month);
                          setPatientDobYear(year);
                          setIsPatientDobPristine(false);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* Patient card */}
              <div className="fx mt-4">
                {/* Avatar */}
                <div className={css(styles.sideDrawerUserCardAvatar)}>
                  <img
                    src={patientAvatarImageUrl}
                    ref={drawerAvatarRef}
                    alt="avatar"
                    className={css(styles.sideDrawerUserCardAvatarImg)}
                    onClick={() => { }}
                  />
                  <div
                    onClick={() => { }}
                    className={css(styles.sideDrawerAvatarCamera)}
                  >
                    <i className="fa fa-camera" />
                  </div>
                </div>
                {/* User card displayName & userName */}
                <div className={`ml-2 ${css(styles.sideDrawerUserCardText)}`}>
                  {/* Display Name */}
                  <div style={{ marginTop: '-16px' }}>
                    <TextInputWithLabel
                      value={patientDisplayName}
                      titleText="Display Name (2 to 40 characters)*"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={268}
                      onChange={handleOnEditPatientDisplayName}
                    />
                    {/* Error message */}
                    {!isPatientDisplayNameValid && !isPatientDisplayNamePristine
                      ? <div className={css(styles.errMsg)}>
                        Invalid Display Name
                      </div>
                      : null
                    }
                  </div>
                  {/* UserName */}
                  <div
                    style={{
                      marginTop: (!isPatientDisplayNameValid && !isPatientDisplayNamePristine) ? '0px' : '4px'
                    }}
                  >
                    <TextInputWithLabel
                      value={patientUserName}
                      titleText="Username (2 to 20 characters, no spaces) *"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor={blue[500]}
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={268}
                      onChange={handleOnEditPatientUserName}
                    />
                    {/* Error message */}
                    {!isPatientUserNameValid && !isPatientUserNamePristine
                      ? <div className={css(styles.errMsg)}>
                        Invalid User Name
                      </div>
                      : null
                    }
                    {isPatientUserNameValid && !isPatientUserNamePristine && isPatientUserNameDuplicate
                      ? <div className={css(styles.errMsg)}>
                        User Name Taken
                      </div>
                      : null
                    }
                  </div>
                </div>
              </div>
              {/* Home Address */}
              <div className='mt-4'>
                {/* Heading */}
                <div className="fx fx__v-center" style={{ color: '#96c8ff' }}>
                  <i className="fa fa-home" style={{ fontSize: '18px' }} />
                  <div className="ml-2" style={{ fontSize: '14px', fontWeight: 'bold' }} >
                    Home Address
                  </div>
                </div>
                {/* Address */}
                <div className="fx">
                  <div>
                    <TextInputWithLabel
                      value={patientHomeStreetAddress}
                      titleText="Street"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={304}
                      placeholder='Required'
                      onChange={handleOnEditPatientHomeStreetAddress}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={patientHomeSuite}
                      titleText="Suite"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={45}
                      onChange={handleOnEditPatientHomeSuite}
                    />
                  </div>
                </div>
                {/* City, State and Zip */}
                <div className="fx mt-2">
                  <div>
                    <TextInputWithLabel
                      value={patientHomeCity}
                      titleText="City"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={206}
                      placeholder='Required'
                      onChange={handleOnEditPatientHomeCity}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={patientHomeState}
                      titleText="State"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={65}
                      placeholder='Required'
                      onChange={handleOnEditPatientHomeState}
                    />
                  </div>
                  <div className="ml-2">
                    <TextInputWithLabel
                      value={patientHomeZip}
                      titleText="Zip"
                      titleFontSize={12}
                      isCompactLayout={true}
                      titleColor={gray[200]}
                      textColor="white"
                      selectionColor="white"
                      selectionBackground="#0080FF"
                      spellcheck={false}
                      width={68}
                      placeholder='Required'
                      onChange={handleOnEditPatientHomeZip}
                    />
                  </div>
                </div>
              </div>
              {/* Mailing Address */}
              <div className='mt-4'>
                {/* Heading */}
                <div className="fx fx__v-center" style={{ color: '#96c8ff' }} >
                  <i className="fa fa-envelope" style={{ fontSize: '18px' }} />
                  <div className="ml-2" style={{ fontSize: '14px', fontWeight: 'bold' }} >
                    Mailing Address
                  </div>
                  <div style={{ marginLeft: '50px', fontSize: '14px', color: '#96C8FF' }} >
                    <Checkbox
                      text='Same as Home Address'
                      isChecked={isPatientMailingAddressSameAsHomeAddress}
                      onChange={() => {
                        setIsPatientMailingAddressSameAsHomeAddress(!isPatientMailingAddressSameAsHomeAddress);
                      }}
                    />
                  </div>
                </div>
                {/* Address */}
                {!isPatientMailingAddressSameAsHomeAddress &&
                  <div className="fx">
                    <div>
                      <TextInputWithLabel
                        value={patientMailingStreetAddress}
                        titleText="Street"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={304}
                        placeholder='Required'
                        onChange={handleOnEditPatientMailingStreetAddress}
                      />
                    </div>
                    <div className="ml-2">
                      <TextInputWithLabel
                        value={patientMailingSuite}
                        titleText="Suite"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={45}
                        onChange={handleOnEditPatientMailingSuite}
                      />
                    </div>
                  </div>
                }
                {/* City, State and Zip */}
                {!isPatientMailingAddressSameAsHomeAddress &&
                  <div className="fx mt-2">
                    <div>
                      <TextInputWithLabel
                        value={patientMailingCity}
                        titleText="City"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={206}
                        placeholder='Required'
                        onChange={handleOnEditPatientMailingCity}
                      />
                    </div>
                    <div className="ml-2">
                      <TextInputWithLabel
                        value={patientMailingState}
                        titleText="State"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={65}
                        placeholder='Required'
                        onChange={handleOnEditPatientMailingState}
                      />
                    </div>
                    <div className="ml-2">
                      <TextInputWithLabel
                        value={patientMailingZip}
                        titleText="Zip"
                        titleFontSize={12}
                        isCompactLayout={true}
                        titleColor={gray[200]}
                        textColor="white"
                        selectionColor="white"
                        selectionBackground="#0080FF"
                        spellcheck={false}
                        width={68}
                        placeholder='Required'
                        onChange={handleOnEditPatientMailingZip}
                      />
                    </div>
                  </div>
                }
              </div>
              {/* Contact # (Mobile or Phone) */}
              <div
                className='fx mt-4'
                style={{
                  position: 'relative',
                  padding: '0'
                }}
              >
                <div>
                  <TextInputWithLabel
                    value={patientMobile}
                    titleText="Contact #"
                    isCompactLayout={false}
                    showPreIcon
                    preIcon={`fa fa-lg ${patientContactType.toLowerCase() === 'mobile' ? 'fa-mobile' : 'fa-phone'}`}
                    titleColor="#60A0E0"
                    textColor="#0080FF"
                    selectionColor="white"
                    selectionBackground="#0080FF"
                    spellcheck={false}
                    width={174}
                    placeholder='Required'
                    onChange={handleOnEditPatientMobile}
                  />
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    position: 'relative',
                    left: '-90px',
                    color: blue[500]
                  }}
                  ref={contactRef}
                  onClick={() => setIsContactMenuOpen(true)}
                >
                  {patientContactType.toLowerCase() === 'mobile' ? 'Mobile' : 'Landline'}&nbsp;&nbsp;<i style={{ fontSize: '14px' }} className='fa fa-caret-down' />
                </div>
                <PopupMenu
                  top={20}
                  left={84}
                  visible={isContactMenuOpen}
                  parent={contactRef}
                  position="absolute"
                  onOutsideClick={() => { setIsContactMenuOpen(false); }}
                >
                  <div className={css(styles.popupMenuContainer)}>
                    {/* Mobile */}
                    <div
                      className={`${patientContactType === 'mobile' ? 'selected' : ''} ${css(styles.popupMenuItemSmall, patientContactType === 'mobile' && styles.selectedPopupMenuItemSmall)}`}
                      onClick={() => {
                        handleOnChangePatientContactType('mobile');
                        setIsContactMenuOpen(false);
                      }}
                    >
                      <div className={css(styles.menuItemIconContainerSmall)}>
                        <i className={`fa fa-mobile ${css(styles.menuItemIconSmall)}`} />
                      </div>
                      <div className='ml-2'>Mobile</div>
                    </div>
                    {/* Landline */}
                    <div
                      className={`${patientContactType === 'landline' ? 'selected' : ''} ${css(styles.popupMenuItemSmall, patientContactType === 'landline' && styles.selectedPopupMenuItemSmall)}`}
                      onClick={() => {
                        handleOnChangePatientContactType('landline');
                        setIsContactMenuOpen(false);
                      }}
                    >
                      <div className={css(styles.menuItemIconContainerSmall)}>
                        <i className={`fa fa-phone ${css(styles.menuItemIconSmall)}`} />
                      </div>
                      <div className='ml-2'>Landline</div>
                    </div>
                  </div>
                </PopupMenu>
              </div>
              {/* Email */}
              <div className='mt-4'>
                <TextInputWithLabel
                  value={patientEmail}
                  titleText="Email"
                  isCompactLayout={false}
                  showPreIcon
                  preIcon='fa fa-envelope'
                  titleColor="#60A0E0"
                  textColor="#0080FF"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={356}
                  placeholder='Required'
                  onChange={handleOnEditPatientEmail}
                />
              </div>
              {/* Patient ID - Front */}
              <div className='mt-4'>
                <div className='fx'>
                  {idIcon}
                  <div className='ml-2'>
                    Patient ID (Front)
                  </div>
                </div>
                {showFrontIdLoader
                  ? <Loader iconType="cog" iconSize="5x" text="Uploading Patient ID(Front)" />
                  : <div style={{ position: 'relative' }}>
                    <img
                      className='mt-2'
                      onClick={() => toggleFrontCropperDrawer(true)}
                      ref={frontCardRef}
                      src={patientFrontIdImageUrl || 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg'}
                      style={{
                        width: '343px',
                        maxWidth: '343px',
                        height: 'auto'
                      }}
                    />
                    {/* Camera Icon */}
                    <div
                      onClick={() => toggleFrontCropperDrawer(true)}
                      className={css(styles.drawerBannerCameraIcon)}
                    >
                      <i className="fa fa-camera" />
                    </div>
                  </div>
                }
              </div>
              {/* Patient ID - Back */}
              <div className='mt-4 mb-2'>
                <div className='fx'>
                  {idIcon}
                  <div className='ml-2'>
                    Patient ID (Back)
                  </div>
                </div>
                {showBackIdLoader
                  ? <Loader iconType="cog" iconSize="5x" text="Uploading Patient ID(Back)" />
                  : <div style={{ position: 'relative' }}>
                    <img
                      className='mt-2'
                      ref={backCardRef}
                      src={patientBackIdImageUrl || 'https://quantumtrader.s3.amazonaws.com/default_insurance.jpg'}
                      style={{
                        width: '343px',
                        maxWidth: '343px',
                        height: 'auto'
                      }}
                    />
                    <div
                      onClick={() => toggleBackCropperDrawer(true)}
                      className={css(styles.drawerBannerCameraIcon)}
                    >
                      <i className="fa fa-camera" />
                    </div>
                  </div>
                }
              </div>
              <div style={{ height: '50px' }} />
            </div>
            {/* Drawer Footer */}
            <div
              className={`fx ${css(styles.sideDrawerFooter)}`}
              style={{ position: 'absolute', bottom: '0', alignItems: 'center', justifyContent: 'flex-end' }}
            >
              {/* Cancel Button */}
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                isOutlineBtn
                onClick={() => setShowEditPatientDrawer(false)}
                style={{
                  height: '32px',
                  width: '85px',
                  padding: '3px 0'
                }}
              >
                Cancel
              </Button>
              {/* Accept Button */}
              <Button
                btnType="primary"
                isDisabled={!canUpdatePatient}
                className="ml-2 fx fx__hv-center"
                onClick={handleOnClickSavePatientProfile}
                style={{
                  height: '32px',
                  width: '85px',
                  padding: '3px 0'
                }}
              >
                Accept
              </Button>
            </div>
          </div>
        </Drawer>
      }

      {Object.keys(patientData).length > 0
        ? <PatientInfo
          patientData={patientData}
          className='p-2'
          onDeletePatient={handleOnDeletePatient}
          onEdit={handleOnEditPatient}
        />
        : <AddPatientToSchedule
          className='p-2'
          isCaseSchedule
          caseData={{ _id: 'scheduleId' }}
          onAddPatient={props.onAddPatient}
        />
      }
    </>
  );
};

function mapStateToProps({ caseSchedule }) {
  return { ...caseSchedule };
};

PatientTab.defaultProps = {
  isDashboard: false
};

export default connect(mapStateToProps, {
  deletePatientFromNewCaseSchedule,
  deletePatientFromCaseSchedule
})(PatientTab);
